import React from 'react';
import styled from 'styled-components';

const CardWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #666;
`;

const CardBrand = styled.span`
  text-transform: capitalize;
`;

const formatCardBrand = (brand) => {
  if (!brand) return '';

  const brandMap = {
    visa: 'Visa',
    mastercard: 'Mastercard',
    amex: 'Amex',
    american_express: 'Amex',
    discover: 'Discover',
    diners: 'Diners',
    jcb: 'JCB',
    unionpay: 'UnionPay',
  };

  return brandMap[brand.toLowerCase()] || brand;
};

const PaymentCardDisplay = ({ cardBrand, cardLast4 }) => {
  if (!cardBrand && !cardLast4) {
    return <CardWrapper>Payment processed</CardWrapper>;
  }

  return (
    <CardWrapper>
      <CardBrand>{formatCardBrand(cardBrand)}</CardBrand>
      {cardLast4 && <span>****{cardLast4}</span>}
    </CardWrapper>
  );
};

export default PaymentCardDisplay;
